module.exports = __webpack_public_path__ + "h5/img/wytx2.0029dbb2.png";